import { SpaceType } from '@sharedlib/common/types/SpaceType';

import { type WorkspaceItem } from './item-workspace-scope';

/** The space on screen, as `SpaceContextStore` reads it. */
export interface ActivitySpace {
  type(): SpaceType;
  contextId(): string | null | undefined;
}

/**
 * The team whose change history an item's Activity tab reads: a persisted item of the shared space on screen. None for
 * a personal space, a draft, or an item of another account, so the tab is not offered. One rule for the reader that
 * adds the tab and for the mail skeleton that holds its place.
 */
export function itemActivityTenant(space: ActivitySpace, item: WorkspaceItem | undefined): string | undefined {
  if (!item?.id || !item.accountId || space.type() !== SpaceType.SHARED_SPACE || item.accountId !== space.contextId()) {
    return undefined;
  }
  return item.accountId;
}
